import { MODELS_LIST } from 'src/store/ActionTypes';
import { INITIAL_STATE } from 'src/store/reducers/models_list';
import { saveStateToLocalStorage } from 'src/store/middleware/local_storage';

const MODELS_LIST_KEY = 'modelsList';

/**
 * Prepares the state object to deep copy values
 * that shouldn't be saved or need set to default
 * @param {object} state - The current state object from the middelware getState() method
 * @returns {object} The prepared state object
 */
const prepareState = (state) => ({
  modelsList: {
    ...INITIAL_STATE,
    gridState: {
      ...INITIAL_STATE.gridState,
      actuarial: {
        ...INITIAL_STATE.gridState.actuarial,
        expanded: state.modelsList.gridState.actuarial.expanded,
      },
    },
  },
});

const modelsListSetGridStateMiddleware =
  ({ getState }) =>
  (next) =>
  (action) => {
    const response = next(action);

    try {
      if (action.type === MODELS_LIST.SET_GRID_STATE) {
        const preparedState = prepareState(getState());
        saveStateToLocalStorage(MODELS_LIST_KEY, preparedState);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }

    return response;
  };

export default [modelsListSetGridStateMiddleware];
